// extracted by mini-css-extract-plugin
export default {"list":"contenderFormControl_list__7dl38","btn":"contenderFormControl_btn__kX7ii"};